<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="all"
      :footer-props="{
        itemsPerPageText: 'Filas por página'
      }"
      :loading="loading"
      :options.sync="optionsLocal"
      :server-items-length="itemsLength"
      disable-sort
      @click:row="onSelect"
    >
      <template v-slot:item.vigencia="{ item }">
        <div v-if="item.vigencia">
          {{ item.vigencia | moment('DD/MM/YYYY') }}
        </div>
      </template>
      <template v-slot:item.subsidio="{ item }">
        <div v-if="item.subsidio">
          $ {{ item.subsidio | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.usuario="{ item }">
        <div v-if="item.usuario">
          $ {{ item.usuario | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.pleno="{ item }">
        <div v-if="item.pleno">
          $ {{ item.pleno | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.id="{ item }">
        <div v-if="item.subsidio && item.usuario">
          $ {{ (item.subsidio + item.usuario) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:no-data>
        <v-alert color="warning" icon="mdi-alert">
          No hay información de precios para mostrar.
        </v-alert>
      </template>
      <template v-slot:pageText="props">
        Filas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
    <precios-edit v-model="dialogEdit"></precios-edit>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PreciosEdit from '@/pages/precios/EditComponent'
import PeriodoMixin from '@/mixins/Periodo'
export default {
  name: 'PreciosDatatableComponent',
  components: {
    'precios-edit': PreciosEdit
  },
  mixins: [PeriodoMixin],
  data () {
    return {
      dialogEdit: false
    }
  },
  created () {
    // this.onFetch()
  },
  computed: {
    ...mapGetters('Precios', ['edited', 'all', 'headers', 'loading', 'itemsLength', 'options']),
    optionsLocal: {
      get () {
        return this.options
      },
      set (value) {
        this.setOptions(value)
        this.onFetch()
      }
    },
  },
  methods: {
    ...mapActions('Precios', ['onFetch']),
    ...mapMutations('Precios', ['setEdited', 'setSelected', 'setOptions']),
    onSelect (item) {
      /* Se cargan los datos en la variable Seleccionado para comparar */
      if(this.$can('precios.update')) {
        const aux = {
          ...this.edited,
          id: item.id,
          vigencia: item.vigencia,
          subsidio: item.subsidio,
          usuario: item.usuario,
          pleno: item.pleno,
          detalle: item.detalle,
          created_at: item.created_at,
          updated_at: item.updated_at
        }
        this.setEdited(aux)
        this.setSelected(aux)
        this.dialogEdit = true
      }
    },
    onPeriodo(fecha) {
      return this.periodoFechaTo(fecha);
    }
  }
}
</script>
